export default Object.freeze({
  LOCAL: 'local',
  S3: 's3',
  BACKBLAZE: 'backblaze',
  DROPBOX: 'dropbox',
  DRIVE: 'drive',
});
